export default "__VITE_ASSET__949e9f58__"